import ACSkeletonBox from 'academy-common-lib/components/loading/ACSkeletonBox';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const randomWidthLookup = ['100%', '95%', '85%'];
export const SkeletonGroup = ({
  rows,
  variableWidth = false,
  marginBlockStart,
  marginBlockEnd
}) => {
  const boxes = [];
  for (let i = 0; i < rows; i++) {
    const randomIndex = Math.floor(Math.random() * 3);
    boxes.push( /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(ACSkeletonBox, {
        animated: true,
        style: {
          height: '17px',
          width: variableWidth ? randomWidthLookup[randomIndex] : '100%'
        }
      }, `${i}${randomIndex}`)
    }));
  }
  return /*#__PURE__*/_jsx(View, {
    as: "section",
    marginBlockEnd: marginBlockEnd,
    marginBlockStart: marginBlockStart,
    children: /*#__PURE__*/_jsx("section", {
      children: boxes
    })
  });
};